import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import Swal from 'sweetalert2'

import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { update } from '../../../../Functions/admin';
import { toastTimerValue, roles } from '../../../../Shared/utils';

import '../../../SweetAlert.css'


export default function UpdateGroup({groups, setGroups, selectedGroup, setSelectedGroup}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [newGroup, setNewGroup] = useState(selectedGroup);

  const [{ user }, appDispatch] = useAppContext();
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();

  // console.log("30 - newGroup.sQL_ID=", newGroup.sQL_ID);
  const [enableSQLID, setEnableSQLID] = useState(
    newGroup.sQL_ID === null || newGroup.sQL_ID === "" || user.roleId === roles.dashboardSuperAdmin || false
  );
  // console.log("34 - enableSQLID=", enableSQLID);

  const handleEditGroup = (e, group) => {
    e.preventDefault();
    setLoading(true);

    update({type: 'group', group}).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.groups.errors.' + res, { name: group.name })), { type: 'error' });
      }

      const newGroups = groups.slice(); // .slice() creates a new array
      for (const [index, row] of newGroups.entries()) {
        if (row.id === res.group.id) {
          newGroups[index] = res.group; break;
        }
      }

      // update default groups sorting in case of name change
      setGroups(newGroups.sort((a, b) => a.name.localeCompare(b.name)));

      setSelectedGroup(null);
      toast(decodeHTMLEntities(t('admin.groups.update.success', { name: group.name })), { type: 'success' });

      appDispatch({ forceReload: true, forceReloadScenario: true });
      eventDispatch({ groupsLocationsStatus: 'pending' });
    });
  };


  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleEditGroup(e, newGroup)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1 title={selectedGroup.name}>{t('admin.groups.update.title', {name: selectedGroup.name})}</h1>
            <div style={{textAlign: 'unset', width: '50%', margin: '20px auto 0'}}>
              <FormControl variant="outlined" style={{width: '100%'}}>
                <InputLabel>{t('admin.groups.columns.management')}</InputLabel>
                <Select
                  value={newGroup.management}
                  label={t('admin.groups.columns.management')}
                  onChange={e => {
                    const management = e.target.value;
                    const pageSize = management === 'US' ? 'LETTER' : 'A4';
                    setNewGroup({...newGroup, management, pageSize});
                  }}
                >
                  <MenuItem value="France">France</MenuItem>
                  <MenuItem value="US">US</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="prompt__content">
            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">description</span>
                </InputAdornment>
              }}
              required
              variant="outlined"
              value={newGroup.name}
              inputProps={{maxLength: 50}}
              label={t('admin.groups.columns.name')}
              onChange={e => setNewGroup({...newGroup, name: e.target.value})}
            />
          </div>

          <div className="prompt__content">
            <TextField              
              variant="outlined"
              value={newGroup.sQL_ID}
              inputProps={{ maxLength: 4, readOnly: !enableSQLID }}
              label={t('admin.groups.columns.sql_id')}
              onChange={e => {
                
                const regex = /^[0-9]{0,4}$/gs;  //                 
                const isValid = regex.test(e.target.value);

                if (isValid) {
                  setNewGroup({ ...newGroup, sQL_ID: e.target.value })
                }
                else {                
                  if (newGroup.sQL_ID === null)
                    setNewGroup({ ...newGroup, sQL_ID: "" })
                }             
              }}
            />
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedGroup(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.save')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
